import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  footer: {
    textAlign: 'center',
    width: '100%',
    marginBottom: '100px',
  },
  withSidebar: {
    backgroundColor: theme.palette.common.white,
  },
  footerLink: {
    padding: `0px ${theme.spacing(0.5)}px`,
    color: theme.palette.common.blue400,
  },
}));
